// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

// Whether a project's data requests keep it from being deleted: an imagery request ops are still
// sourcing, or a raster request neither cancelled nor closed by its order (AUT-6554). Shared by the
// grid card and the list row, so the two presentations offer Delete on the same projects.

export const dataRequestBlocksDelete = (
  imageryRequest?: IImageryRequest | null,
  rasterRequest?: IRasterRequest | null,
): boolean => {
  const imageryInFlight = Boolean(
    imageryRequest?.requested && !imageryRequest.rejected && !imageryRequest.uploaded && !imageryRequest.notificationSent,
  );
  const rasterOpen = Boolean(rasterRequest?.requested && !rasterRequest.rejected && !rasterRequest.orderPlaced);
  return imageryInFlight || rasterOpen;
};

export default dataRequestBlocksDelete;
